window.arjoEifu = window.arjoEifu || {
  isInitialized: false,
  eifuTermsAcceptedKey: 'arjo-eifu-terms-accepted',
  uiLanguageKey: 'arjo-eifu-ui-language',
  uiLanguageDataKey: 'arjo-eifu-ui-language-data',
  eifuTermsAccepted: false,
  mainElement: null,
  selectedCountry: null,
  selectedLanguage: null,
  uiLanguage: null,
  isProcessing: false,
  setUILanguage: function (data, language, persist) {
    if (!data) {
      return;
    }

    if (persist) {
      if (language) {
        localStorage.setItem(this.uiLanguageKey, language);
      }
      localStorage.setItem(this.uiLanguageDataKey, JSON.stringify(data));
    }

    if (data.title) {
      const eifuHeader = this.mainElement.querySelector('#eifu-header');
      if (eifuHeader) {
        eifuHeader.textContent = data.title;
      }
    }

    if (data.terms) {
      const eifuTerms = this.mainElement.querySelector('.arjo-t-eifu__instruction-1 > .arjo-m-rich-text__content > .col-12');
      if (eifuTerms) {
        eifuTerms.innerHTML = data.terms;
      }
    }

    if (data.instruction) {
      const eifuTerms = this.mainElement.querySelector('.arjo-t-eifu__instruction-2 > .arjo-m-rich-text__content > .col-12');
      if (eifuTerms) {
        eifuTerms.innerHTML = data.instruction;
      }
    }

    if (data.searchLabel) {
      const searchButton = this.mainElement.querySelector('.arjo-t-eifu__lang-selector > .arjo-a-button');
      if (searchButton) {
        searchButton.textContent = data.searchLabel;
      }
    }

    if (data.acceptLabel) {
      const acceptButton = this.mainElement.querySelector('.arjo-t-eifu__terms > .arjo-t-eifu__buttons > .arjo-a-button');
      if (acceptButton) {
        acceptButton.textContent = data.acceptLabel;
      }
    }

    if (data.termStatement) {
      const termStatement = this.mainElement.querySelector('.arjo-t-eifu__terms-statement');
      if (termStatement) {
        termStatement.innerHTML = data.termStatement;
      }
    }

    if (data.chooseCountryLabel) {
      const chooseCountryInput = this.mainElement.querySelector('.arjo-m-dropdown[data-dropdown-id="countryCode"] input[data-placeholder]');
      if (chooseCountryInput) {
        chooseCountryInput.setAttribute('data-label', data.chooseCountryLabel);
      }

      const chooseCountryLabel = this.mainElement.querySelector('.arjo-m-dropdown[data-dropdown-id="countryCode"] input[data-placeholder] + label');
      if (chooseCountryLabel) {
        chooseCountryLabel.textContent = data.chooseCountryLabel;
      }
    }

    if (data.chooseLanguageLabel) {
      const chooseLanguageInput = this.mainElement.querySelector('.arjo-m-dropdown[data-dropdown-id="languageCode"] input[data-placeholder]');
      if (chooseLanguageInput) {
        chooseLanguageInput.setAttribute('data-label', data.chooseLanguageLabel);
      }

      const chooseLanguageLabel = this.mainElement.querySelector('.arjo-m-dropdown[data-dropdown-id="languageCode"] input[data-placeholder] + label');
      if (chooseLanguageLabel) {
        chooseLanguageLabel.textContent = data.chooseLanguageLabel;
      }
    }

    if (data.filterForDocumentLabel) {
      const filterForDocumentLabel = document.getElementById('eifu-query');
      if (filterForDocumentLabel) {
        filterForDocumentLabel.setAttribute('placeholder', data.filterForDocumentLabel);
      }
    }
  },
  changeUILanguage: function () {
    if (!this.selectedCountry || !this.selectedLanguage) {
      return;
    }

    let apiUrl = this.mainElement.getAttribute('data-ui-localization-url');
    if (!apiUrl) {
      return;
    }

    apiUrl = apiUrl
      .replace('{{country}}', encodeURIComponent(this.selectedCountry))
      .replace('{{language}}', encodeURIComponent(this.selectedLanguage));

    const langSelector = this.mainElement.querySelector('.arjo-t-eifu__lang-selector');
    const termsLabel = this.mainElement.querySelector('.arjo-t-eifu__accept-terms');
    const termsInput = this.mainElement.querySelector('#eifu-term-checkbox');

    const spinner = document.querySelector('.arjo-t-eifu__instruction > .arjo-t-eifu__spinner');
    if (spinner) {
      spinner.style.display = 'block';
    }

    if (langSelector) {
      langSelector.style.opacity = 0.5;
      langSelector.style.pointerEvents = 'none';
    }
    if (termsLabel) {
      termsLabel.style.opacity = 0.5;
      termsLabel.style.pointerEvents = 'none';
    }
    if (termsInput) {
      termsInput.checked = false;
      termsInput.disabled = true;
    }

    axios
      .get(apiUrl)
      .then((response) => {
        this.setUILanguage(response.data, this.uiLanguage, true);
      })
      .catch((error) => {
        console.log('error!', error);
      })
      .then(() => {
        if (spinner) {
          spinner.style.removeProperty('display');
        }

        if (langSelector) {
          langSelector.style.removeProperty('opacity');
          langSelector.style.removeProperty('pointer-events');
        }
        if (termsLabel && this.selectedCountry && this.selectedLanguage) {
          termsLabel.style.removeProperty('opacity');
          termsLabel.style.removeProperty('pointer-events');
        }
        if (termsInput) {
          termsInput.disabled = false;
        }
      });
  },
  hideUnavailableLanguages: function (langSelector) {
    const options = langSelector.querySelectorAll('.arjo-m-dropdown__options-input[data-countries]');
    [].forEach.call(options, (opt) => {
      const countriesAttr = opt.getAttribute('data-countries');
      if (!countriesAttr) {
        return;
      }
      const countries = countriesAttr.split(',');
      if (countries.includes(this.selectedCountry) || countriesAttr.includes('all')) {
        opt.removeAttribute('data-hidden');
      } else {
        opt.setAttribute('data-hidden', '');
      }
    });
  },
  setupLangSelector: function () {
    const countrySelector = this.mainElement.querySelector('.arjo-m-dropdown[data-dropdown-id="countryCode"]');
    const langSelector = this.mainElement.querySelector('.arjo-m-dropdown[data-dropdown-id="languageCode"]');

    const selectedCountryInput = countrySelector.querySelector('input[name=countryCode]:checked');
    if (selectedCountryInput) {
      this.selectedCountry = selectedCountryInput.value;
    }

    const selectedLanguageInput = langSelector.querySelector('input[name=languageCode]:checked');
    if (selectedLanguageInput) {
      this.selectedLanguage = selectedLanguageInput.value;
    }

    if (!countrySelector || !langSelector) {
      console.log("eIFU's language selector is not available!");
      return;
    }

    countrySelector.addEventListener('dropdownChange', (e) => {
      this.selectedCountry = e.detail.value;

      const eventInfo = {
        detail: {
          value: '',
        },
      };
      const customEvent = new CustomEvent('optionChange', eventInfo);
      langSelector.dispatchEvent(customEvent);

      if (!this.eifuTermsAccepted) {
        const termCheckbox = document.getElementById('eifu-term-checkbox');
        if (termCheckbox && termCheckbox.checked) {
          termCheckbox.click();
        }
      }

      this.updateVisual(countrySelector, langSelector);
    });

    langSelector.addEventListener('dropdownChange', (e) => {
      this.selectedLanguage = e.detail.value;
      const termCheckbox = document.getElementById('eifu-term-checkbox');
      if (termCheckbox) {
        if (termCheckbox.checked) {
          termCheckbox.click();
        }
        this.changeUILanguage();
      }
      this.updateVisual(countrySelector, langSelector);
    });

    this.updateVisual(countrySelector, langSelector);
  },

  updateVisual: function (countrySelector, langSelector, queryElement) {
    if (!this.selectedCountry) {
      langSelector.style.pointerEvents = 'none';
      langSelector.style.opacity = '0.5';
    } else {
      langSelector.style.removeProperty('pointer-events');
      langSelector.style.removeProperty('opacity');
    }
    this.hideUnavailableLanguages(langSelector);

    const searchButton = document.querySelector('.arjo-t-eifu__lang-selector > .arjo-a-button');
    if (searchButton) {
      searchButton.disabled = !this.selectedCountry || !this.selectedLanguage;
    }

    const acceptButton = this.mainElement.querySelector('.arjo-t-eifu__terms button[type=submit]');
    if (acceptButton) {
      acceptButton.disabled = !this.selectedCountry || !this.selectedLanguage || !this.eifuTermsAccepted;
    }

    const terms = this.mainElement.querySelector('.arjo-t-eifu__terms');
    if (terms) {
      if (!(this.selectedCountry && this.selectedLanguage)) {
        terms.style.opacity = 0.5;
        terms.style.pointerEvents = 'none';
      } else {
        terms.style.removeProperty('opacity');
        terms.style.removeProperty('pointer-events');
      }
    }
  },
  filterResults: function (filterQuery) {
    const terms = filterQuery.split(/(\s+)/).map((term) => term.trim().toLowerCase());
    const items = document.querySelectorAll('.arjo-o-eifu-search-result tbody tr');
    items.forEach((item) => {
      let itemContent = item.textContent.toLowerCase();
      const titles = item.querySelectorAll('[title]');
      [].forEach.call(titles, (title) => (itemContent += '\n' + title.getAttribute('title').toLowerCase()));
      if ([].every.call(terms, (term) => itemContent.includes(term))) {
        item.style.removeProperty('display');
      } else {
        item.style.display = 'none';
      }
    });
  },
  getEifuProducts: function (queryElement, contentContainer, resultContainer) {
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;
    if (!this.selectedCountry || !this.selectedLanguage) {
      this.isProcessing = false;
      return;
    }

    const searchUrl = resultContainer.getAttribute('data-search-url');
    if (!searchUrl) {
      this.isProcessing = false;
      return;
    }

    const searchUrlWithParams = searchUrl
      .replace('{{country}}', encodeURIComponent(this.selectedCountry))
      .replace('{{language}}', encodeURIComponent(this.selectedLanguage));

    contentContainer.style.pointerEvents = 'none';
    const spinner = document.querySelector('.arjo-t-eifu__content > .arjo-t-eifu__spinner');
    if (spinner) {
      spinner.style.display = 'block';
    }

    const stateUrl = new URL(window.location.href);
    stateUrl.searchParams.set('country', this.selectedCountry);
    stateUrl.searchParams.set('language', this.selectedLanguage);
    window.history.replaceState('', '', stateUrl);

    axios
      .get(searchUrlWithParams)
      .then((response) => {
        if (!response.data) {
          resultContainer.innerHTML = '';
          this.isProcessing = false;
          return;
        }

        if (spinner) {
          spinner.style.removeProperty('display');
        }

        resultContainer.innerHTML = response.data;
        return response.data;
      })
      .catch((error) => {
        resultContainer.innerHTML = '';
      })
      .then(() => {
        this.isProcessing = false;

        queryElement.value = '';
        queryElement.style.display = resultContainer.querySelector('.arjo-o-eifu-search-result') ? 'block' : 'none';

        if (spinner) {
          spinner.style.removeProperty('display');
        }

        contentContainer.style.removeProperty('pointer-events');
      });
  },
  init: function () {
    if (this.isInitialized) {
      return;
    }
    this.isInitialized = true;

    this.mainElement = document.querySelector('.arjo-t-eifu');
    const countrySelector = this.mainElement.querySelector('.arjo-m-dropdown[data-dropdown-id="countryCode"]');
    const langSelector = this.mainElement.querySelector('.arjo-m-dropdown[data-dropdown-id="languageCode"]');

    if (!this.mainElement || !countrySelector || !langSelector) {
      return;
    }

    const queryElement = document.getElementById('eifu-query');
    if (queryElement) {
      queryElement.addEventListener('change', () => this.filterResults(queryElement.value));
      queryElement.addEventListener('input', () => this.filterResults(queryElement.value));
      queryElement.addEventListener('keyup', (e) => {
        if (e.key === 'Escape') {
          queryElement.value = '';
          this.filterResults(queryElement.value);
        }
      });
    }

    const termCheckbox = document.getElementById('eifu-term-checkbox');
    if (termCheckbox) {
      termCheckbox.addEventListener('change', () => {
        this.eifuTermsAccepted = termCheckbox.checked;
        this.updateVisual(countrySelector, langSelector);
      });
    }

    this.setupLangSelector(queryElement);
  },
};

window.addEventListener('load', function () {
  window.arjoEifu.init();
});
